
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-600 to-orange-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/bb961440-a650-4543-bd88-152698c0f8f2.png"
              alt="Digital Domination LLC"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-white/90 mb-4">
              DIGITAL DOMINATION LLC
              <br />
              8025 TANK LOOP ST
              <br />
              LAS VEGAS NV 89166
            </p>
            <p className="text-sm text-white/90">
              <strong>Phone:</strong> +1 (725) 275-6972
              <br />
              <strong>Email:</strong> domination@thompsondigital.org
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-white/90 hover:text-white transition-colors"
                >
                  Products & Services
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-policy"
                  className="text-sm text-white/90 hover:text-white transition-colors"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-white/90 hover:text-white transition-colors"
                >
                  Privacy & Confidentiality Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Business Hours</h3>
            <p className="text-sm text-white/90">
              Monday - Friday: 9:00 AM - 6:00 PM PST
              <br />
              Saturday: 10:00 AM - 4:00 PM PST
              <br />
              Sunday: Closed
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-white/80 mb-4 md:mb-0">
            © {new Date().getFullYear()} Digital Domination LLC. All Rights Reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/80 hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
